import { apiClient } from '@/lib/api/client'

const API_BASE = '/system-settings/content-push'

export type ContentPushTargetScope = 'all' | 'cluster' | 'region' | 'user'

export interface ContentPackageListParams {
  per_page?: number
  page?: number
  [key: string]: unknown
}

export interface PublishPayload {
  title: string
  type: string
  payload: Record<string, unknown>
  target_scope: ContentPushTargetScope
  target_ids?: number[] | string[]
}

export interface DeliveryListParams {
  per_page?: number
  page?: number
  [key: string]: unknown
}

export const ContentPushService = {
  async listPackages(params?: ContentPackageListParams) {
    const response = await apiClient.get(API_BASE, { params })
    return response.data
  },

  async publish(payload: PublishPayload) {
    const response = await apiClient.post(API_BASE, payload)
    return response.data
  },

  async listDeliveries(params?: DeliveryListParams) {
    const response = await apiClient.get(`${API_BASE}/deliveries`, { params })
    return response.data
  },

  async retryFailed(packageId?: number) {
    const body = packageId !== undefined ? { package_id: packageId } : {}
    const response = await apiClient.post(`${API_BASE}/retry-failed`, body)
    return response.data
  },
}
